module.exports = __webpack_public_path__ + "media/images/qc-bottom-6dd8819f460d96d2ccec91cc53dc9680.jpg";